import type { AuditLogApiFilter } from '@circuitry-ai/doc-data';

export const ADVISOR_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'aiworker', condition: 'equals' },
  { sub_module: ['advisor', 'advisor_config'], condition: 'in' },
];

export const AGENT_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'aiworker', condition: 'equals' },
  { sub_module: ['agent','agent_config'], condition: 'in' },
];

export const ANALYST_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'aiworker', condition: 'equals' },
  { sub_module: 'analyst', condition: 'equals' },
];

export const ACTIONS_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'sources', condition: 'equals' },
  { sub_module: 'action', condition: 'equals' },
];

export const KNOWLEDGE_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'sources', condition: 'equals' },
  { sub_module: 'knowledge', condition: 'equals' },
];

export const CREDENTIAL_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'credentials_management', condition: 'equals' },
];

export const SCHEDULER_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'event_scheduler', condition: 'equals' },
];

export const FGA_AUDIT_LOG_STATIC_FILTERS: AuditLogApiFilter[] = [
  { module: 'fga', condition: 'equals' },
  {
    sub_module: [
      'group',
      'group_member',
      'group_permission',
      'application_resource',
      'entity_type',
      'entity_resource',
      'user',
      'store',
      'auth_model',
      'script',
    ],
    condition: 'in',
  },
];

/** Per-advisor audit logs inside advisor view (scheduler + advisor scope + advisor_id metadata). */
export function getAdvisorViewAuditLogStaticFilters(advisorId: string): AuditLogApiFilter[] {
  return [
    { module: 'aiworker', condition: 'equals' },
    { sub_module: ["advisor", "advisor_config"], condition: "in" },
    { resource_id: advisorId, condition: 'equals' }
  ];
}

/** Per-advisor knowledge audit logs inside advisor knowledge view. */
export function getAdvisorKnowledgeViewAuditLogStaticFilters(advisorId: string): AuditLogApiFilter[] {
  return [
    { module: 'sources', condition: 'equals' },
    { sub_module: 'knowledge', condition: 'equals' },
    {
      metadata: [
        { key: 'advisor_id', value: advisorId, condition: 'equals' },
      ],
    },
  ];
}

/** Per-analyst audit logs inside analyst view. */
export function getAnalystViewAuditLogStaticFilters(aiworkerId: string): AuditLogApiFilter[] {
  return [
    { module: 'aiworker', condition: 'equals' },
    { sub_module: 'analyst', condition: 'equals' },
    { resource_id: aiworkerId, condition: 'equals' },
  ];
}

/** Per-agent audit logs inside agent view. */
export function getAgentViewAuditLogStaticFilters(aiworkerId: string): AuditLogApiFilter[] {
  return [
    { module: 'aiworker', condition: 'equals' },
    { sub_module: ['agent', 'agent_config'], condition: 'in' },
    { resource_id: aiworkerId, condition: 'equals' },
  ];
}

/** Per-action audit logs inside action view. */
export function getActionViewAuditLogStaticFilters(sourceId: string): AuditLogApiFilter[] {
  return [
    { module: 'sources', condition: 'equals' },
    { sub_module: 'action', condition: 'equals' },
    { resource_id: sourceId, condition: 'equals' },
  ];
}
